import { render } from "./home-trade.vue?vue&type=template&id=7264d95c"
import script from "./home-trade.vue?vue&type=script&lang=js"
export * from "./home-trade.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__